export default {
    // Desktop first
    lteXSmall: '(max-width: 480px)',
    lteSmall: '(max-width: 600px)',
    lteMedium: '(max-width: 900px)',
    lteLarge: '(max-width: 1440px)',
    lteXLarge: '(max-width: 1920px)',
    // Mobile first
    gteSmall: '(min-width: 600px)',
    gteMedium: '(min-width: 900px)',
    gteLarge: '(min-width: 1440px)',
    gteXLarge: '(min-width: 1920px)',
    // Use these to target a specific range
    xsmall: '(max-width: 480px)',
    small: '(min-width: 480px AND max-width: 600px)',
    medium: '(min-width: 600px AND max-width: 900px)',
    large: '(min-width: 900px AND max-width: 1440px)',
    xlarge: '(min-width: 1440px AND max-width: 1920px)',
    xxlarge: '(min-width: 1920px)',
};
